import axios from "axios";

export const headersConfig = {
    withCredentials: true,
};

export const api = axios.create({
    baseURL: "https://inovartgold.com.br/ws/ecommerce/",
    withCredentials: true,
});
